import { useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { userApi } from '../../../services/user';

const useHeader = () => {
  const [searchQuery, setSearchQuery] = useState('');
  const [searchResults, setSearchResults] = useState<any[]>([]);
  const [isSearchLoading, setIsSearchLoading] = useState(false);

  const navigate = useNavigate();

  const onSearch = useCallback(
    (value: string) => {
      setSearchQuery(value);
      // Navigate to search results page or handle search
      navigate(`/search?q=${value}`);
    },
    [navigate]
  );

  const fetchHeaderSuggestions = useCallback(async (query: string) => {
    if (!query || query.length < 2) {
      setSearchResults([]);
      return [];
    }

    setIsSearchLoading(true);
    try {
      // TODO: Replace with actual API call for search suggestions
      // const response = await fetch(`${API_BASE_URL}/search/suggestions?q=${query}`);
      // const data = await response.json();
      // setSearchResults(data);
      // return data;

      // Placeholder for now
      setSearchResults([]);
      return [];
    } catch (error) {
      console.error('Error fetching search suggestions:', error);
      setSearchResults([]);
      return [];
    } finally {
      setIsSearchLoading(false);
    }
  }, []);

  // Get user data with refetch capability
  const { data: userData, refetch: refetchUserData } = userApi.useGetUserQuery(
    '',
    {
      refetchOnMountOrArgChange: true,
      // pollingInterval: 10000,
    }
  );

  return {
    onSearch,
    searchQuery,
    searchResults,
    isSearchLoading,
    fetchHeaderSuggestions,
    userData,
    refetchUserData,
  };
};

export default useHeader;
